
import React, { useState, useEffect, useRef } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineSearch } from 'react-icons/ai';
import { FaPrint } from 'react-icons/fa';
import UserLogo from '../../assets/user-logo.png';


const StudentIdCard = ({ setLoading }) => {
  const [classes, setClasses] = useState([]);
  const [std, setStd] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const printRef = useRef(null);

  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Initial fetches for classes and academic years
  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
  }, []);

  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);

  // New: Search function to fetch filtered students
  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedAY || !selectedClassId) {
      alert('Please select both Academic Year and Class to search.');
      return;
    }

    setLoading(true);

    try {
      // Get class_name from classId
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-student?${params.toString()}`;

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);
      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


    const handlePrint = () => {
    if (!std.length) {
      setResponse2({ message: 'No Staff ID Cards to Print', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }
    window.print();
  };

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Student' message2='Student ID Cards' />

          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>&nbsp;&nbsp;
             <button
              className="profile-btn2"
              onClick={handlePrint}
              disabled={!std.length}
            >
              <FaPrint /> Print
            </button>
            </div>
          </form>


        </div>
      </section>

           <div ref={printRef} className="printable-area px-4">
             <div className="row">
               {std.map((student, index) => (
                <div
                  className="col-lg-3 col-md-6 col-12 my-2"
                  key={student.id || index}
                >
                  <div className="staff-icard">
                    <p className="staff-icard-heading">K C Public School</p>

                    <img
                      src={
                        student.profile_pic && student.profile_pic.trim() !== ''
                          ? `https://api.kcian.in/inUploads/${student.profile_pic}`
                          : UserLogo
                      }
                      className="icard-img"
                      alt={student.name}
                    />

                    <p className="bg-light para-text mt-3 py-2 fw-semibold">
                      {student.name}
                      <br />
                      {student.class_name}({student.section})
                    </p>
                    <p className='para-text'>
                      Reg No: {student.reg_no}
                      <br />
                      Mobile: {student.mobile}
                      <br />
                      Blood Grp: {student.blood_grp || '-'}
                      <br />
                      Address: {student.address || '-'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>


       {/* Add print-specific styles */}
       <style>{`
 @media print {
   body * {
     visibility: hidden;
   }
   .printable-area, .printable-area * {
     visibility: visible;
   }
   .printable-area {
     position: absolute;
     left: 0;
     top: 0;
     width: 100%;
   }
   .staff-icard {
     page-break-inside: avoid;
     -webkit-print-color-adjust: exact;
   }
   .d-print-none {
     display: none !important;
   }
   .printable-area .row {
     display: flex !important;
     flex-wrap: wrap !important;
   }
   .printable-area .col-lg-3{ 
     flex: 0 0 50% !important;
     max-width: 50% !important;
   }
 }

       `}</style>

    </>
  );
};

export default StudentIdCard;
